// extracted by mini-css-extract-plugin
module.exports = {"subtotal":"Subtotal_subtotal__31UkP","subtotal__gift":"Subtotal_subtotal__gift__3PYDP"};